// Canonical home for ServiceType + ServiceCategory per ADR-015.
//
// Brief: docs/projects/q7-service-type-vocabulary.md
//
// All downstream consumers (apps/api, apps/sync, apps/web, apps/mobile,
// packages/core/validation) MUST import the vocabulary from this file
// — no app-local SERVICE_TYPES constants. The pre-Q7 fragmentation
// (5 source-file copies with 4 divergent value sets, tracked as TASK-43)
// is the prior art this file replaces.
//
// Hard cutover (Q7 D4): the vocabulary is the canonical 10. Pre-Q7
// values reaching HCM-side schemas (post Session 4) return 422.
// Nsofar wire compatibility lives in nsofar-translation.ts, NOT here.
export const SERVICE_CATEGORIES = [
    "care_visit",
    "delivery",
    "teleconsult",
    "diagnostics",
    "property",
    "other",
];
export const SERVICE_TYPES = [
    "elder_care_visit",
    "post_discharge_care",
    "companion_visit",
    "medical_nursing",
    "medicine_delivery",
    "tele_consult",
    "diagnostics_visit",
    "nutritionist_call",
    "property_visit",
    "other",
];
export const SERVICE_TYPE_TO_CATEGORY = {
    elder_care_visit: "care_visit",
    post_discharge_care: "care_visit",
    companion_visit: "care_visit",
    medical_nursing: "care_visit",
    medicine_delivery: "delivery",
    tele_consult: "teleconsult",
    diagnostics_visit: "diagnostics",
    nutritionist_call: "teleconsult",
    property_visit: "property",
    other: "other",
};
export function categoryOf(serviceType) {
    return SERVICE_TYPE_TO_CATEGORY[serviceType];
}
// Display labels — canonical home so dropdowns, filters, and detail views
// don't drift in casing/spacing. Q7 S4 added these when frontend rolled
// over to the canonical 10; before that each consumer hand-rolled labels.
export const SERVICE_TYPE_LABELS = {
    elder_care_visit: "Elder Care Visit",
    post_discharge_care: "Post Discharge Care",
    companion_visit: "Companion Visit",
    medical_nursing: "Medical Nursing",
    medicine_delivery: "Medicine Delivery",
    tele_consult: "Tele Consult",
    nutritionist_call: "Nutritionist Call",
    diagnostics_visit: "Diagnostics Visit",
    property_visit: "Property Visit",
    other: "Other",
};
export const SERVICE_CATEGORY_LABELS = {
    care_visit: "Care Visit",
    delivery: "Delivery",
    teleconsult: "Tele Consult",
    diagnostics: "Diagnostics",
    property: "Property",
    other: "Other",
};
// Returns the canonical 10 grouped by category, in SERVICE_CATEGORIES order
// (and SERVICE_TYPES order within each group). Empty groups are omitted —
// today every category has ≥1 type, but a future enum addition that
// orphans a category should not render an empty <optgroup>.
export function serviceTypesByCategory() {
    return SERVICE_CATEGORIES
        .map((category) => ({
        category,
        label: SERVICE_CATEGORY_LABELS[category],
        types: SERVICE_TYPES
            .filter((st) => SERVICE_TYPE_TO_CATEGORY[st] === category)
            .map((st) => ({ value: st, label: SERVICE_TYPE_LABELS[st] })),
    }))
        .filter((g) => g.types.length > 0);
}
// Q7 D3 — alias-and-remember. Values that existed in production data
// pre-Q7 but are intentionally NOT in the canonical 10. Persisted on
// migrated rows in `legacy_service_type` (see Q7 S5 migration script).
// New SR documents NEVER write `legacy_service_type`.
export const LEGACY_SERVICE_TYPES = ["pmjay"];
//# sourceMappingURL=service-type.js.map